// extracted by mini-css-extract-plugin
export default {"IntlPhoneNumberInput__Option":"intlPhoneOption_IntlPhoneNumberInput__Option_jDpg4"};